import React, { useState, useEffect } from "react";
import { getLoadingUnloadingRecords } from "../services/deliveryService"; // Service to fetch records
import toast from "react-hot-toast";

const ViewLoadingUnloadingRecords = () => {
  // State to store records and selected date filter
  const [records, setRecords] = useState([]);
  const [selectedDate, setSelectedDate] = useState(""); // Date filter state

  useEffect(() => {
    const fetchRecords = async () => {
      try {
        const data = await getLoadingUnloadingRecords(); // Call service to fetch records
        setRecords(data.data);
      } catch (error) {
        console.error("Error fetching records:", error);
        toast.error("Failed to load records.");
      }
    };

    fetchRecords();
  }, []);

  // Group records by date
  const groupedRecords = records.reduce((acc, record) => {
    const { date } = record;
    if (!acc[date]) {
      acc[date] = [];
    }
    acc[date].push(record);
    return acc;
  }, {});

  // Filtered records based on selected date
  const filteredRecords = selectedDate
    ? groupedRecords[selectedDate]
    : Object.values(groupedRecords).flat();

  return (
    <div className="container mx-auto p-6 bg-gray-50 rounded-xl shadow-lg max-w-6xl">
      <h2 className="text-3xl font-bold text-center text-gray-800 mb-6">
        Loading/Unloading Records
      </h2>

      {/* Date Filter (Date Picker) */}
      <div className="mb-6">
        <label htmlFor="date-filter" className="text-sm font-medium text-gray-700">
          Filter by Date:
        </label>
        <input
          type="date"
          id="date-filter"
          className="p-2 border border-gray-300 rounded-md mt-2"
          value={selectedDate}
          onChange={(e) => setSelectedDate(e.target.value)}
        />
      </div>

      {/* Loop through filtered records */}
      {filteredRecords.length > 0 ? (
        filteredRecords.map((record, index) => {
          const isCoolBottle = record.product_id === 1;
          const isPetBottle = record.product_id === 2;

          return (
            <div key={index} className="mb-8">
              {/* Card for each product */}
              <div className="bg-white rounded-lg shadow-md p-6">
                <h4 className="text-xl font-semibold text-gray-700 mb-4">
                  {isCoolBottle ? "Cool Bottle 🛢️" : "Pet Bottle 🍼"}
                </h4>
                <p className="text-sm text-gray-500 mb-4">Date: {record.date}</p>

                <div className="mb-4">
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-700">Quantity Loaded:</span>
                    <p className="text-gray-600">{record.quantity_loaded}</p>
                  </div>
                  <div className="flex justify-between mt-2">
                    <span className="font-medium text-gray-700">Quantity Unloaded:</span>
                    <p className="text-gray-600">{record.quantity_unloaded}</p>
                  </div>
                </div>
              </div>
            </div>
          );
        })
      ) : (
        <div className="text-center text-gray-600">No records available.</div>
      )}
    </div>
  );
};

export default ViewLoadingUnloadingRecords;
